import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::deleteMethod
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
export const deleteMethod = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/material-resource/{material_resource}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::deleteMethod
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
deleteMethod.url = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { material_resource: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { material_resource: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            material_resource: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        material_resource: typeof args.material_resource === 'object'
        ? args.material_resource.id
        : args.material_resource,
    }

    return deleteMethod.definition.url
            .replace('{material_resource}', parsedArgs.material_resource.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::deleteMethod
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/{material_resource}'
*/
deleteMethod.delete = (args: { material_resource: string | number | { id: string | number } } | [material_resource: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::undo
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/material-resource/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::undo
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::undo
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MaterialResource\DeleteMaterialResourceController::undo
* @see app/Http/Controllers/MaterialResource/DeleteMaterialResourceController.php
* @route '/api/material-resource/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteMaterialResourceController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteMaterialResourceController